import React, { useEffect, useState } from 'react';
import axios from '../api/axios';
import Sidebar from '../components/Sidebar';
import { toast } from 'react-toastify';

function BankTransfer() {
  const [banks, setBanks] = useState([]);
  const [fromBank, setFromBank] = useState('');
  const [toBank, setToBank] = useState('');
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [fromBalance, setFromBalance] = useState(0);

  useEffect(() => {
    axios.get('/banks').then(res => setBanks(res.data));
  }, []);

  useEffect(() => {
    const selected = banks.find(b => b.id === parseInt(fromBank));
    setFromBalance(selected?.balance || 0);
  }, [fromBank, banks]);

  const handleTransfer = async (e) => {
    e.preventDefault();
    if (!fromBank || !toBank || !amount) {
      toast.error('Please fill in all fields');
      return;
    }
    if (parseFloat(amount) > fromBalance) {
      toast.error('Insufficient balance in source bank');
      return;
    }
    try {
      await axios.post('/banks/transfer', {
        from_bank_id: fromBank,
        to_bank_id: toBank,
        amount: parseFloat(amount),
        description
      });
      toast.success('Transfer successful!');
      setAmount('');
      setDescription('');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Transfer failed');
    }
  };
  useEffect(() => {
    const selected = banks.find(b => b.id === parseInt(fromBank));
    setFromBalance(parseFloat(selected?.balance || 0));
  }, [fromBank, banks]);
  return (
    <div className="flex">
      
      <div className="p-6 w-full">
        <h2 className="text-2xl font-bold mb-4">Bank to Bank Transfer</h2>
        <form onSubmit={handleTransfer} className="space-y-4 max-w-xl">
          <div>
            <label className="block font-semibold">From Bank</label>
            <select value={fromBank} onChange={e => setFromBank(e.target.value)} className="border p-2 w-full">
              <option value="">Select Bank</option>
              {banks.map(b => (
                <option key={b.id} value={b.id}>
                  {b.name} — Balance: ${parseFloat(b.balance || 0).toFixed(2)}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block font-semibold">To Bank</label>
            <select value={toBank} onChange={e => setToBank(e.target.value)} className="border p-2 w-full">
              <option value="">Select Bank</option>
              {banks.map(b => (
                <option key={b.id} value={b.id}>{b.name}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block font-semibold">Amount</label>
            <input type="number" value={amount} onChange={e => setAmount(e.target.value)} className="border p-2 w-full" />
            {fromBank && <p className="text-sm text-gray-500 mt-1">Available: ${parseFloat(fromBalance || 0).toFixed(2)}</p>}
          </div>

          <div>
            <label className="block font-semibold">Description</label>
            <textarea value={description} onChange={e => setDescription(e.target.value)} className="border p-2 w-full"></textarea>
          </div>

          <button type="submit" className="bg-blue-600 text-white px-6 py-2 rounded">Transfer</button>
        </form>
      </div>
    </div>
  );
}

export default BankTransfer;